import { ActionTypes } from "../Constants/ActionTypes";

const initialState = {
  url: "",
  disableScreen: false,
  isDrawerOpen: true,
  isMobileDevice: false,
};

export const SchoolAdminDashboardReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case ActionTypes.TOGGLE_DRAWER:
      return {
        ...state,
        isDrawerOpen: payload,
      };

    case ActionTypes.IS_MOBILE_DEVICE:
      return {
        ...state,
        isMobileDevice: payload,
      };

    case ActionTypes.SET_DISABLE_SCREEN:
      return {
        ...state,
        disableScreen: payload,
      };
    case ActionTypes.SET_SCHOOL_ADMIN_PROFILE_IMAGE:
      return {
        ...state,
        url: payload,
      };

    case ActionTypes.RESET_SCHOOL_ADMIN_INFORMATION:
      return initialState;

    default:
      return state;
  }
};
